<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded ? 'Кратко' : 'Подробно'" :expandable="items.length > 0">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        <div>
        Филиалы ({{branchItems.length}})
        </div>      
        <div>
          Представительства ({{repItems.length}})
        </div>      
      </div>  
    </v-panel-title>
    <v-card-text v-show="isLoaded" class="pt-0">
      <div v-show="!isLoading">
        <v-flex v-if="items.length===0">
          Данные не найдены.
        </v-flex>
        <div>
          Филиалы ({{branchItems.length}})
          <template v-for="item in branchItems">
            <div>
              <b>{{item.name}}</b>
              <v-flex pl-2>
                {{item.address.value}}
                <span v-html="renderDateSince(item)"></span>
              </v-flex>
            </div>
          </template>
        </div>      
        <div>
          Представительства ({{repItems.length}})
          <template v-for="item in repItems">
            <div>
              <b>{{item.name}}</b>
              <v-flex pl-2>
                {{item.address.value}}
                <span v-html="renderDateSince(item)"></span>
              </v-flex>
            </div>
          </template>
        </div>      
      </div>  
      </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import server from '../../api/server'
  import vPanelTitle from './PanelTitle'

  export default {
    name: 'v-branches-panel',
    components: {vPanelTitle},
    data: () => ({
      id: null,
      items: [],
      isLoaded: false,
      isLoading: false
    }),
    props: {
      ogrn: {
        type: Number,
        default: null
      },
      fillHeight: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      ogrn: function (newVal, oldVal) { // watch it
        this.id = newVal
        if (this.id) {
          this.fetchItems()
        }
      }
    },
    computed: {
      ...mapGetters({
        renderDateSince: 'renderDateSince'
      }),
      branchItems () {
        return this.items.filter(a => a.kind === 'BRANCH')
      },
      repItems () {
        return this.items.filter(a => a.kind === 'REP_OFFICE')
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded && this.items.length === 0) {
          this.fetchItems()
        }
      },
      sortItems (a, b) {
        const getRank = (kind) => ['BRANCH', 'REP_OFFICE'].indexOf(kind)

        var result = 0
        if (!result) {
          result = getRank(a.type) - getRank(b.type)
        }
        if (!result) {
          result = formats.compareString(a.name, b.name)
        }
        if (!result) {
          result = a.address && formats.compareString(a.address.value, b.address.value) || -1
        }
        return result
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о филиалах и представительствах компаний из ЕГРЮЛ '})
        }
        server.openApiGet(
          '/openapi/companies/' + id + '/branches',
          cb,
          cbError)
      },
      fetchItems () {
        if (this.id && !this.isLoading) {
          this.items = []
          this.isLoading = true
          this.getItems(this.id, (data) => {
            this.items = data
            this.isLoading = false
            this.items.sort((a, b) => this.sortItems(a, b))
          })
        }
      }
    }
  }

</script>




// WEBPACK FOOTER //
// BranchesPanel.vue?72a87cff